/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Col_Lot_CodeInputs */

const vi_sinp_col_lot_code = /** @type {(inputs: Sinp_Col_Lot_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô`)
};

/**

* @param {Sinp_Col_Lot_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_col_lot_code = /** @type {((inputs?: Sinp_Col_Lot_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Col_Lot_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_col_lot_code(inputs)
});